module.exports = "../content/59cf0995782240777656a355cf08b234.ttf";